<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left w-100">
        <ul>
          <li class="link">
            {{ text }}
          </li>
          <li class="f-right">
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>

<script>
  export default {
    data () {
      return {
        text: process.env.PATIENT_SUPPORT_INFO
      }
    }
  }

</script>
<style scoped>

.footer nav ul li {
    display: inline-block;
    padding: 0px 0px;
    margin: 17px 0px;
}

.w-100{
  width: 100%;
}

.f-right{
  float: right;
}

.link{
  line-height: 2.9;
  float: left;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue